<template>
    <section class="email-application">
        <div class="modal modal-sticky" id="compose-mail">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" :class="{ 'modal-fullscreen': isMaximize }">
                <div class="modal-content p-0">
                    <div class="modal-header">
                        <h5 class="modal-title">Compose Mail</h5>
                        <div class="modal-actions">
                            <a @click="toggleMaximize" href="javascript:void(0);" class="text-body mr-75">
                                <vue-feather type="maximize-2"></vue-feather>
                            </a>
                            <a @click="closeModal()" class="text-body" href="javascript:void(0);">
                                <vue-feather type="x"></vue-feather>
                            </a>
                        </div>
                    </div>
                    <div class="modal-body flex-grow-1 p-0">
                        <form class="compose-form">
                            <div class="compose-mail-form-field select2-primary">
                                <label for="email-from" class="form-label">From: </label>
                                <div class="flex-grow-1">
                                    <select v-model="selectedFromEmail" class="form-control w-100">
                                        <option v-for="fromEmail in fromEmails" :value="fromEmail.email_address_id">{{ fromEmail.email_address }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="compose-mail-form-field select2-primary">
                                <label for="email-to" class="form-label">To: </label>
                                <div class="flex-grow-1">
                                    <vue-tags-input
                                        v-model="emailInput.to.email"
                                        :tags="emailInput.to.emails"
                                        @tags-changed="newEmail => emailInput.to.emails = newEmail"
                                        placeholder="Enter Email"
                                        class="border-0"
                                    />
                                </div>
                                <div>
                                    <a @click="toggleVisibility('cc')" class="text-body mr-1" href="javascript:void(0);">Cc</a>
                                    <a @click="toggleVisibility('bcc')" class="text-body" href="javascript:void(0);">Bcc</a>
                                </div>
                            </div>
                            <div v-show="isVisible.cc" class="compose-mail-form-field">
                                <label for="emailCC">Cc: </label>
                                <div class="flex-grow-1">
                                    <vue-tags-input
                                        v-model="emailInput.cc.email"
                                        :tags="emailInput.cc.emails"
                                        @tags-changed="newEmail => emailInput.cc.emails = newEmail"
                                        placeholder="Enter Email"
                                        class="border-0"
                                    />
                                </div>
                                <a @click="toggleVisibility('cc')" class="text-body" href="javascript:void(0);">
                                    <i data-feather="x"></i>
                                </a>
                            </div>
                            <div v-show="isVisible.bcc" class="compose-mail-form-field">
                                <label for="emailBCC">Bcc: </label>
                                <div class="flex-grow-1">
                                    <vue-tags-input
                                        v-model="emailInput.bcc.email"
                                        :tags="emailInput.bcc.emails"
                                        @tags-changed="newEmail => emailInput.bcc.emails = newEmail"
                                        placeholder="Enter Email"
                                        class="border-0"
                                    />
                                </div>
                                <a @click="toggleVisibility('bcc')" class="text-body" href="javascript:void(0);">
                                    <i data-feather="x"></i>
                                </a>
                            </div>
                            <div class="compose-mail-form-field">
                                <label for="subject">Subject: </label>
                                <input type="text" v-model="subject" id="subject" class="form-control" placeholder="Subject" name="subject" />
                            </div>
                            <div id="message-editor">
                                <div class="editor" data-placeholder="Type message..."></div>
                                <div class="compose-editor-toolbar">
                                    <span class="ql-formats mr-0">
                                        <select class="ql-font">
                                            <option selected>Sailec Light</option>
                                            <option value="sofia">Sofia Pro</option>
                                            <option value="slabo">Slabo 27px</option>
                                            <option value="roboto">Roboto Slab</option>
                                            <option value="inconsolata">Inconsolata</option>
                                            <option value="ubuntu">Ubuntu Mono</option>
                                        </select>
                                    </span>
                                    <span class="ql-formats mr-0">
                                        <button class="ql-bold"></button>
                                        <button class="ql-italic"></button>
                                        <button class="ql-underline"></button>
                                        <button class="ql-link"></button>
                                    </span>
                                </div>
                            </div>
                            <div class="mail-attachments p-1">
                                <div class="d-flex align-items-center mb-1">
                                    <i data-feather="paperclip" class="font-medium-1 mr-50"></i>
                                    <h5 class="font-weight-bolder text-body mb-0">{{ attachments.length }} Attachments</h5>
                                </div>
                                <div class="d-flex flex-column">
                                    <a v-for="attachment in attachments" href="javascript:void(0);" class="mb-50">
                                        <img
                                            :src="attachment.type.includes('application') ? (baseUrl + '/images/icons/doc.png') : (baseUrl + '/images/icons/jpg.png')"
                                            class="mr-25 image-small"
                                            alt="attachment.filename"
                                            height="18"
                                        />
                                        <small class="text-muted font-weight-bolder">{{ attachment.filename }}</small>
                                    </a>
                                </div>
                            </div>
                            <div class="compose-footer-wrapper">
                                <div class="btn-wrapper d-flex align-items-center">
                                    <div class="btn-group dropup mr-1">
                                        <button @click="create" type="button" class="btn btn-primary">
                                            Send
                                        </button>
                                        <!-- <button
                                            type="button"
                                            class="btn btn-primary dropdown-toggle dropdown-toggle-split"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            data-reference="parent"
                                        >
                                            <span class="sr-only">Toggle Dropdown</span>
                                        </button>
                                        <div class="dropdown-menu">
                                            <a class="dropdown-item" href="javascript:void(0);"> Schedule Send</a>
                                        </div> -->
                                    </div>
                                    <!-- add attachment -->
                                    <div class="email-attachement">
                                        <label for="file-input" style="cursor: pointer;">
                                            <i data-feather="paperclip" width="17" height="17" class="ml-50"></i>
                                        </label>
                                        <input id="file-input" type="file" class="d-none" @change="updateAttachments" multiple />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style>
    .ti-tag {
        background-color: #4b9a5e !important;
    }
</style>
<script>
    import { ref, reactive, computed, defineComponent, inject } from 'vue'
    import VueTagsInput from '@sipec/vue3-tags-input'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useSettingStore } from '../../stores/SettingStore.js'
    import { useClicksendStore } from '../../stores/ClicksendStore.js'
    import { useLoading } from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        props: {
            haveLetter: Boolean
        },
        mounted() {
            if (!useSettingStore().isSettingFetched) {
                useSettingStore().fetchSetting();
            }
            else {
                this.getEmails();
            }
            let $this = this;
            $(document).on("click",".compose-mail-button",function(event) {
                event.preventDefault();
                if (!$this.settingStore.isClicksendUpdated) {
                    toastr.error(
                        $this.localizationStore.translate("clicksend.setting.error.message"),
                        'Error!'
                    );
                    return;
                }
                if (!$this.clicksendStore.isCredentialValid) {
                    toastr.error(
                        $this.localizationStore.translate("clicksend.credentials.wrong.error.message"),
                        'Error!'
                    );
                    return;
                }
                $this.letterId = $(this).data('id');
                $this.attachments.length = 0;
                if ($this.haveLetter) {
                    $this.loader = $this.loading.show({
                        color: '#4b9a5e',
                        loader: 'spinner',
                        width: 64,
                        height: 64,
                    });
                    const route = $this.$router.resolve(
                        {
                            name: 'letter-download-url',
                            params: {
                                letterUser: $this.letterId,
                                client: $this.$route.params.client,
                                team: $this.$route.params.team
                            },
                            query: { 'instruction-page': 'false' }
                        }
                    );
                    $this.convertUrlToBase64(route.href)
                    .then(function(response) {
                        $this.attachments.push({
                            content: response,
                            type: 'application/pdf',
                            filename: `letter_${$this.letterId}.pdf`,
                            disposition: "attachment",
                            content_id: 'application/pdf'
                        });
                        $('#compose-mail').show();
                        $this.loader.hide();
                    }).catch(function(error) {
                        console.log(error);
                    });
                }
                else {
                    $('#compose-mail').show();
                }
            });
        },
        components: {
            VueTagsInput
        },
        setup(props) {
            return {
                settingStore: useSettingStore(),
                isVisible: reactive(
                    {
                        'cc': false,
                        'bcc': false
                    }
                ),
                fromEmails: reactive([]),
                selectedFromEmail: ref(''),
                emailInput: reactive({
                    'to': {
                        email: '',
                        emails: []
                    },
                    'cc': {
                        email: '',
                        emails: []
                    },
                    'bcc': {
                        email: '',
                        emails: []
                    },
                }),
                subject: ref(''),
                attachments: reactive([]),
                letterId: ref(''),
                baseUrl: baseUrl,
                isMaximize: ref(false),
                fullPage: ref(false),
                loader: ref(null),
                loading: useLoading(),
                localizationStore: useLocalizationStore(),
                clicksendStore: useClicksendStore(),
            }
        },
        watch: {
            'settingStore.isSettingFetched'(value) {
                if (value) {
                    this.getEmails();
                }
            },
        },
        methods: {
            toggleVisibility(type) {
                this.isVisible[type] = !this.isVisible[type];
            },
            create() {
                let $this = this, selectedEmailAddress = _.find($this.fromEmails, function(email) { return email.email_address_id == $this.selectedFromEmail; });
                if (this.emailInput.to.emails.length == 0) {
                    toastr.error("To is Required", 'Error!');
                    return;
                }
                $this.loader = $this.loading.show({
                    color: '#4b9a5e',
                    loader: 'spinner',
                    width: 64,
                    height: 64,
                });
                let toEmails = [],
                ccEmails = [],
                bccEmails = [],
                body = $('#message-editor .editor')[0].__quill.getText();
                _.forEach(this.emailInput.to.emails, function(toEmail) {
                    toEmails.push({
                        email: toEmail.text
                    });
                });
                _.forEach(this.emailInput.cc.emails, function(ccEmail) {
                    ccEmails.push({
                        email: ccEmail.text
                    });
                });
                _.forEach(this.emailInput.bcc.emails, function(bccEmail) {
                    bccEmails.push({
                        email: bccEmail.text
                    });
                });
                let url = this.settingStore.getUrl('/email/send'),
                customString = ($this.letterId != '' || (typeof $this.letterId != 'undefined')) ? `{"id": "${$this.letterId}"}` : "";
                axios.post(
                    url,
                    {
                        to: toEmails,
                        cc: $this.isVisible.cc == true ? ccEmails : [],
                        bcc: $this.isVisible.cc == true ? bccEmails : [],
                        from : {
                            email_address_id: selectedEmailAddress.email_address_id,
                            name: selectedEmailAddress.email_address
                        },
                        subject: $this.subject,
                        body: body,
                        attachments: $this.attachments,
                        custom_string: customString
                    },
                    {
                        auth: {
                            username: $this.settingStore.clicksend.clicksend_username,
                            password: $this.settingStore.clicksend.clicksend_password
                        }
                    },
                ).then(function(response) {
                    toastr.success(response.data.response_msg, 'Success!');
                    $this.resetForm();
                    $this.loader.hide();
                    return;
                }).catch(function(error) {
                    toastr.error(error.response.data.response_msg, 'Error!');
                    $this.loader.hide();
                });
            },
            closeModal() {
                $('#compose-mail').hide();
            },
            updateAttachments(event) {
                let $this = this;
                $this.attachments.length = 0;
                $this.loader = $this.loading.show({
                    color: '#4b9a5e',
                    loader: 'spinner',
                    width: 64,
                    height: 64,
                });
                if ($this.haveLetter) {
                    const route = $this.$router.resolve(
                        {
                            name: 'letter-download-url',
                            params: {
                                letterUser: $this.letterId,
                                client: $this.$route.params.client,
                                team: $this.$route.params.team
                            },
                            query: { 'instruction-page': 'false' }
                        }
                    );
                    $this.convertUrlToBase64(route.href)
                    .then(function(response) {
                        $this.attachments.push({
                            content: response,
                            type: 'application/pdf',
                            filename: `letter_${$this.letterId}.pdf`,
                            disposition: "attachment",
                            content_id: 'application/pdf'
                        });
                        _.forEach(event.target.files, function(file) {
                            $this.convertToBase64(file)
                            .then(function(response) {
                                $this.attachments.push({
                                    content: response,
                                    type: file.type,
                                    filename: file.name,
                                    disposition: "attachment",
                                    content_id: file.type
                                });
                            }).catch(function(error) {
                                console.log(error);
                            });
                        });
                        $this.loader.hide();
                    }).catch(function(error) {
                        console.log(error);
                    });
                }
                else {
                    _.forEach(event.target.files, function(file) {
                        $this.convertToBase64(file)
                        .then(function(response) {
                            $this.attachments.push({
                                content: response,
                                type: file.type,
                                filename: file.name,
                                disposition: "attachment",
                                content_id: file.type
                            });
                        }).catch(function(error) {
                            console.log(error);
                        });
                    });
                    $this.loader.hide();
                }
            },
            convertToBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = (error) => reject(error);
                });
            },
            async convertUrlToBase64(url) {
                const data = await fetch(url);
                const blob = await data.blob();
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        const base64data = reader.result;
                        resolve(base64data);
                    }
                });
            },
            resetForm() {
                this.isVisible.cc = false;
                this.isVisible.bcc = false;
                this.emailInput.to.email = '';
                this.emailInput.to.emails = [];
                this.emailInput.cc.email = '';
                this.emailInput.cc.emails = [];
                this.emailInput.bcc.email = '';
                this.emailInput.bcc.emails = [];
                this.subject = '';
                this.attachments.length = 0;
                $('#message-editor .editor')[0].__quill.setText('');
                $('#compose-mail').hide();
            },
            toggleMaximize() {
                this.isMaximize = !this.isMaximize;
            },
            getEmails() {
                let $this = this;
                if ($this.settingStore.isClicksendUpdated) {
                    axios.get(
                        this.settingStore.getUrl('/email/addresses'),
                        {
                            auth: {
                                username: $this.settingStore.clicksend.clicksend_username,
                                password: $this.settingStore.clicksend.clicksend_password
                            }
                        }
                    ).then(function(response) {
                        $this.clicksendStore.isCredentialValid = true;
                        if ($this.fromEmails.length == 0) {
                            _.forEach(response.data.data.data, function(fromEmail) {
                                $this.fromEmails.push(fromEmail);
                            });
                        }
                        $this.selectedFromEmail = _.head($this.fromEmails).email_address_id;
                    }).catch(function(error) {
                        if (error.response.data.http_code == $this.clicksendStore.status.UNAUTHORIZED) {
                            $this.clicksendStore.isCredentialValid = false;
                        }
                        else {
                            setTimeout(() => {
                                toastr.error(error.response.data.response_msg, 'Error!');
                            }, 2000)
                        }

                    });
                }
            }
        },
        computed: {
            getFromEmails() {
                return JSON.stringify(this.fromEmails);
            }
        }
    }
</script>
